// src/lib/anmeldeweg.ts
// Paket 38 (Dominiks Entscheidung 22.10.2026): Registrierung und Login zusätzlich mit Google.
//
// 1. In-App-Browser: Google blockiert OAuth in eingebetteten Browsern (Fehler
//    „403 disallowed_useragent“). Die Meta-Anzeigen öffnen /check im Instagram-/Facebook-
//    Browser (siehe QuickCheckShell.tsx) -- dort blenden Register/Login die Social-Buttons aus,
//    statt Besucher auf eine Google-Fehlerseite zu schicken.
// 2. Registrierungsweg fürs Tracking (sign_up.method): bisher fest "email".

/** Instagram, Facebook, Messenger, Threads, LinkedIn, TikTok, Snapchat, Pinterest, Line -- alles
 *  eingebettete Browser, in denen Google-Anmeldung scheitert. Android-WebViews allgemein („; wv)“). */
const IN_APP_MUSTER = /FBAN|FBAV|FB_IAB|FBIOS|FB4A|Instagram|Messenger|Barcelona|LinkedInApp|BytedanceWebview|musical_ly|TikTok|Snapchat|Pinterest|\bLine\/|; wv\)/i;

export function istInAppBrowser(userAgent: string | null | undefined): boolean {
  if (!userAgent) return false;
  return IN_APP_MUSTER.test(userAgent);
}

/** Für Komponenten: liest navigator.userAgent, ohne Browser (SSR/Tests) immer false. */
export function aktuellerInAppBrowser(): boolean {
  if (typeof navigator === "undefined") return false;
  return istInAppBrowser(navigator.userAgent);
}

/** "google" | "microsoft" | "apple" | … aus Clerks externalAccounts, sonst "email". */
export function registrierungsweg(externalAccounts: ReadonlyArray<{ provider?: string | null }> | null | undefined): string {
  const provider = externalAccounts?.find((a) => a?.provider)?.provider;
  if (!provider) return "email";
  return provider.replace(/^oauth_/, "").toLowerCase();
}

/** CSS, das im In-App-Browser Social-Buttons und die „oder“-Trennlinie von Clerk ausblendet. */
export const SOCIAL_AUSBLENDEN_CSS =
  ".cl-socialButtonsRoot, .cl-socialButtons, .cl-dividerRow { display: none !important; }";
